/* eslint-disable react/prop-types */
// eslint-disable-next-line no-restricted-imports
import { Trans } from '@lingui/macro'
import { ButtonText } from 'components/Button'
import usePlayerData from 'hooks/usePlayerData'
import { useState } from 'react'
import { useDarkModeManager } from 'state/user/hooks'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { isMobile } from 'utils/userAgent'

import BuyChips from './Actions/BuyChips'
import SellChips from './Actions/SellChips'

const PageWrapper = styled.div`
  max-width: 600px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 500px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 400px;
    margin-top: 5rem;
  `};
`

const DataContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  border-radius: 8px;
  border: 1px solid #8247e5;
  padding: 16px;
  margin-top: 2rem;
`

const InfoContent = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.8rem;
`

const DataPosition = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 50%;
`
const Body = styled.div`
  width: 100%;
  padding: 8px;
`

const Chips = () => {
  const [showSection, setShowSection] = useState(0)
  const [darkMode] = useDarkModeManager()

  const playerData = usePlayerData()

  return (
    <PageWrapper>
      <DataContentWrapper>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {showSection === 0 ? (
            <ThemedText.LargeHeader fontSize={isMobile ? '2rem' : '3rem'}>
              <Trans>Buy Chips</Trans>
            </ThemedText.LargeHeader>
          ) : (
            <ThemedText.LargeHeader fontSize={isMobile ? '2rem' : '3rem'}>
              <Trans>Sell Chips</Trans>
            </ThemedText.LargeHeader>
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {darkMode ? (
            <img width={isMobile ? 150 : 200} src={`${process.env.PUBLIC_URL}/images/casino-chips-ico.svg`} alt="" />
          ) : (
            <img
              width={isMobile ? 150 : 200}
              src={`${process.env.PUBLIC_URL}/images/casino-chips-ico-black.svg`}
              alt=""
            />
          )}
        </div>
        <Body>
          <InfoContent>
            <DataPosition style={{ borderRight: '1px solid #8247e5' }}>
              <ButtonText isMobile={isMobile} isActive={showSection === 0} onClick={() => setShowSection(0)}>
                <Trans>Buy</Trans>
              </ButtonText>
            </DataPosition>
            <DataPosition>
              <ButtonText isMobile={isMobile} isActive={showSection === 1} onClick={() => setShowSection(1)}>
                <Trans>Sell</Trans>
              </ButtonText>
            </DataPosition>
          </InfoContent>
        </Body>
        {showSection === 0 ? <BuyChips playerData={playerData} /> : <SellChips playerData={playerData} />}
      </DataContentWrapper>
    </PageWrapper>
  )
}

export default Chips
